<div class="app-container" [class.no-bg]="noBg" [class.full-width]="fullWidth">
  <ng-content></ng-content>
</div>
